import React, { useState, useEffect } from "react";
import axios from "axios";
import { Alert } from "antd";
import { Link, useNavigate } from "react-router-dom";
import AdminHeader from "../AdminHeader";
import AdminFooter from "../AdminFooter";
export const AdminSupervisor = () => {
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [gdata, setgdata] = useState(null);
  const [isClicked, setisClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isClickedclient, setIsClickedclient] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const handlegetClient = () => { };
  const handleuserRemove = (clientid) => { };
  const handleedit = (event) => {
    setIsClickedclient(!isClickedclient);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    var vll = event.target;
    let formdata = {
      email: vll.email.value,
      name: vll.name.value,
      phone: vll.phone.value,
    };
    console.log(formdata);
    axios
      .post(
        "https://jlmining.app/api/adminsupervisor/addsupervisor",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        // console.log(res.data);
        if (res.data.status == "2") {
          setShowAlert(true);
          setShowAlert({ type: "error" });
        } else {
          getsupervisor();
          setShowAlert(true);
          setShowAlert({ type: "success" });
          event.target.reset();
          //(event.target).text()
        }
        setTimeout(() => {
          setShowAlert(false);
        }, 4500);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    //changeFavicon(require("../../assets/admin/images/f-icon.png"));
    document.title = "Add Supervisor Page";
    const userStr = JSON.parse(localStorage.getItem("admin"));
    if (userStr == null) {
      navigate("/admin/login");
    }
    getsupervisor();
  }, []);
  const getsupervisor = () => {
    let formdata = {};
    axios
      .post("https://jlmining.app/api/adminsupervisor/getlist", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        setdata(res.data.results);
      })
      .catch((err) => { });
  };
  const [value, setValue] = useState("");
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Validate input as integer
    if (/^\d*$/.test(inputValue)) {
      setValue(inputValue);
    }
  };
  return (
    <>
      <div>
        <AdminHeader />
        <div className="main-right-body">
          <div className="block-full">
            <div className="row gy-4">
              <div className="col-lg-4">
                <div className="d-block red-heading bg-white shadow p-4">
                  <h3 className="mb-3">SuperVisor</h3>
                  <div className="over-empl">
                    <div className="d-flex flex-column h-100">
                      {Array.isArray(data) && data.length > 0 ? (
                        data.map((item, index) => (
                          <Link to="">{item.name}</Link>
                        ))
                      ) : (
                        <a href="#"> No data available </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                {showAlert?.type === "error" && (
                  <Alert
                    type="error"
                    description="Email is already exist"
                    closable
                  />
                )}
                {showAlert?.type === "success" && (
                  <Alert
                    type="success"
                    description="Successfully created!"
                    closable
                  />
                )}
                <div className="right-form-box bg-white shadow p-4">
                  <form action="" onSubmit={handleSubmit}>
                    <div className="row gy-2">
                      <div className="col-12 col-lg-6">
                        <div className="d-flex flex-column gap-2">
                          <label for="">
                            Name <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="name"
                            required
                            placeholder="type here"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-lg-6">
                        <div className="d-flex flex-column gap-2">
                          <label for="">
                            Email <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="email"
                            required
                            placeholder="type here"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-lg-6">
                        <div className="d-flex flex-column gap-2">
                          <label for="">
                            Phone Number <span className="text-danger">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="phone"
                            required
                            placeholder="type here"
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex align-items-center gap-3 justify-content-end">
                          <button className="sub-btn" type="submit">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminFooter />
      </div>
    </>
  );
};
